import { styled } from "styled-components";
import { SquarebtnProps } from "./types";

export const Squarebtn = styled.button<SquarebtnProps>` 
  background:  ${({$bacgrndColor}) => $bacgrndColor || 'none'};
   z-index: ${({$zIndex}) => $zIndex || 'auto'};
  width: ${({ width }) => width || "150px"};
  height: ${({ height }) => height || "60px"};
  border-radius:  ${({ radius }) => radius || "2px"};
  margin: ${({$margin}) => $margin};
  font-size: ${({$fontSize}) => $fontSize};
  border: ${({ theme, $border }) =>
    $border || `2px solid ${theme.circularIconBg}`};
  color: ${({ theme, $color }) => $color || theme.circularIconBg};
  letter-spacing: 0px;
      transition: ${({$transition}) => $transition || 'letter-spacing 1.5s ease-out'};
  &:hover {
    background: ${({ theme, $hoverBackground }) =>
      $hoverBackground || theme.circularIconBg};
    color: ${({ theme, $hoverColor }) =>
      $hoverColor || theme.circularIconTextBg};
     letter-spacing: 1px;
  }

  position: ${({$position}) => $position || 'relative'};
  top: ${({$top}) => $top || 'auto'};
  right: ${({$right}) => $right || 'auto'};
  overflow: hidden;

  .ripple {
    position: absolute;
    border-radius: 50%;
    background: ${({ theme }) => theme.ripplebg};
    transform: scale(0);
    animation: ripple 0.7s ease-out;
  }

  @keyframes ripple {
    to {
      transform: scale(4);
      opacity: 0;
    }
  }
`;
